import { AccountStatus } from '../proto/consulate/accounts/enums';

export class UserAccount {
  firstname?: string;
  lastname?: string;
  email: string;
  status: AccountStatus;
  createdTs?: Date;
}
